import { useLocation, useParams } from 'react-router-dom';

import { useGetMeetingGroupById } from '@/entities/meeting-groups';
import { routes } from '@/shared/lib';
import { getMeetingGroupByIdRoute } from '@/shared/utils';

export type BreadcrumbItem = {
  label: string;
  href?: string; // если есть - это ссылка, если нет - текущая страница
};

export const useBreadcrumbs = (): BreadcrumbItem[] => {
  const { meetingGroupById, sessionId } = useParams<{
    meetingGroupById?: string;
    sessionId?: string;
  }>();
  const location = useLocation();
  const { data: meetingGroupData, isPending } = useGetMeetingGroupById(meetingGroupById ?? '');

  if (!meetingGroupById) {
    if (location.pathname === routes.MAIN) {
      return [];
    }
    if (location.pathname === routes.PROFILE) {
      return [];
    }
    if (location.pathname.startsWith('/company/')) {
      return [
        {
          label: 'Профиль',
          href: routes.PROFILE,
        },
        {
          label: 'Управление компанией',
          // без href - это текущая страница
        },
      ];
    }
    return [];
  }

  const groupName = isPending ? 'Загрузка...' : (meetingGroupData?.name ?? meetingGroupById);

  const breadcrumbs: BreadcrumbItem[] = [
    {
      label: 'Мои группы',
      href: routes.MAIN,
    },
  ];

  // Если есть sessionId - это страница встречи
  if (sessionId) {
    breadcrumbs.push(
      {
        label: groupName,
        href: getMeetingGroupByIdRoute(meetingGroupById),
      },
      {
        label: 'Встреча',
        // без href - это текущая страница
      },
    );
  } else {
    // Только meetingGroupById - страница группы
    breadcrumbs.push({
      label: groupName,
      // без href - это текущая страница
    });
  }

  return breadcrumbs;
};
